/**
 * ScreenFallback - Loading indicator for lazy-loaded screens
 *
 * Appears only if loading takes >100ms to avoid flash on fast connections.
 *
 * @component
 * @example
 * <Suspense fallback={<ScreenFallback />}>
 *   <HomeScreen />
 * </Suspense>
 */
import { useLanguage } from '@context/LanguageContext'
import styles from './ScreenFallback.module.css'

export default function ScreenFallback () {
  const { t } = useLanguage()

  return (
    <div
      className={styles.screenFallback}
      role='status'
      aria-live='polite'
      aria-label={t.core.access.common.loading}
    >
      <span className={styles.indicator} aria-hidden='true' />
    </div>
  )
}
